<template>
  <div
    :id="`${ idPlayer }`"
  ></div>
    <!-- data-plyr-provider="vimeo"
    :data-plyr-embed-id="video" -->
</template>

<script>
// import Plyr from 'plyr'

export default {
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      video: undefined,
      idPlayer: ""
    }
  },
  beforeMount () {
    this.video = this.item.url.split('/')[2]
    this.idPlayer = `player${ this.video }`
  },
  mounted () {
    // const player = new Plyr(`#${ this.idPlayer }`);
  }
}
</script>

<style>
  #player {
    height: 100%;
  }
</style>
